<template>
  <div
    :class="{
      content: true,
      page: page.total > queryParams.Limit,
    }"
    ref="content"
  >
    <div class="main-content">
      <div class="search-box" ref="search">
        <a-form>
          <a-row>
            <a-col :sm="6" :xxl="4">
              <e-date-time
                title="开始时间"
                :labelCol="8"
                :valueCol="14"
                v-model:value="queryParams.BeginDate"
              />
            </a-col>
            <a-col :sm="6" :xxl="4">
              <e-date-time
                title="结束时间"
                :labelCol="8"
                :valueCol="14"
                v-model:value="queryParams.EndDate"
              />
            </a-col>
            <a-col :sm="5" :xxl="4">
              <e-radio
                title="类型"
                :labelCol="6"
                :valueCol="16"
                v-model:value="queryParams.Type"
                :options="[
                  { label: '日报', value: 0 },
                  { label: '月报', value: 1 },
                ]"
              />
            </a-col>
            <a-col>
              <a-button type="primary" @click="getDataList(1)"> 查询 </a-button>
              <a-button
                type="primary"
                @click="reset(() => resetFun())"
                danger
                style="margin-left: 10px"
              >
                重置
              </a-button>
              <a-button
                type="primary"
                @click="exportExcel"
                style="margin-left: 10px"
              >
                导出Excel
              </a-button>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div class="data-list">
        <a-table
          :columns="columns"
          :data-source="list"
          :pagination="false"
          :loading="loading"
          :row-key="(record) => record.id"
          :scroll="{ y: height, x: width }"
        >
        </a-table>
      </div>
    </div>

    <div class="pagination">
      <a-pagination
        :total="page.total"
        v-model:page-size="queryParams.Limit"
        :hide-on-single-page="true"
        :show-size-changer="true"
        :page-size-options="['20', '40', '100', '200']"
        @change="changePage"
        @showSizeChange="onShowSizeChange"
      >
        <template #itemRender="{ page, type }">
          <a v-if="type === 'prev'" class="ant-pagination-item-link">上一页</a>
          <a v-else-if="type === 'next'" class="ant-pagination-item-link">
            下一页
          </a>
          <span v-else>{{ page }}</span>
        </template>
      </a-pagination>
      <span>数据总数：{{ page.total }}</span>
    </div>
  </div>
</template>

<script>
import { defineComponent, ref } from 'vue'
import {} from '@ant-design/icons-vue'
import { RechargeClass } from '@/apis/fin'
import page from '@/mixins/page'
import dayjs from 'dayjs'
import fileDownload from 'js-file-download'

const api = new RechargeClass()
export default defineComponent({
  mixins: [page],
  components: {},
  setup () {
    const loading = ref(false)
    const height = ref(500)
    const width = ref(500)

    const queryParams = ref({
      Limit: 50
    })
    const columns = [
      {
        title: '日期',
        key: 'date',
        dataIndex: 'date',
        width: 180
      },
      {
        title: '充值次数',
        key: 'rechargeCount',
        dataIndex: 'rechargeCount',
        width: 100
      },
      {
        title: '充值金额',
        key: 'totalPayAmount',
        dataIndex: 'totalPayAmount',
        width: 100
      },
      {
        title: '赠送金额',
        key: 'totalHandselAmount',
        dataIndex: 'totalHandselAmount',
        width: 100
      },
      {
        title: '全民付充值',
        key: 'uninPayAmount',
        dataIndex: 'uninPayAmount',
        width: 100
      },
      {
        title: '微信充值',
        key: 'wechatPayAmount',
        dataIndex: 'wechatPayAmount',
        width: 100
      },
      {
        title: '支付宝充值',
        key: 'alipayAmount',
        dataIndex: 'alipayAmount',
        width: 100
      },
      {
        title: '刷卡充值',
        key: 'bankcardPayAmount',
        dataIndex: 'bankcardPayAmount',
        width: 100
      },
      {
        title: '现金充值',
        key: 'cashPayAmount',
        dataIndex: 'cashPayAmount',
        width: 100
      },
      {
        title: '货款冲抵',
        key: 'goodsPayAmount',
        dataIndex: 'goodsPayAmount',
        width: 100
      }
    ]
    return {
      columns,
      loading,
      height,
      width,
      queryParams
    }
  },
  created () {
    this.getDataList(1)
  },
  methods: {
    getDataList (page) {
      this.loading = true
      this.page.page = page
      const q = { ...this.queryParams }
      q.Offset = (page - 1) * q.Limit

      if (q.BeginDate) {
        q.BeginDate = q.BeginDate.format('YYYY-MM-DD')
      }
      if (q.EndDate) {
        q.EndDate = q.EndDate.format('YYYY-MM-DD')
      }

      api.report(q).then((resp) => {
        this.list = resp.data
        this.page.total = resp.total
        this.loading = false
        this.getTableHeight()
      })
    },
    resetFun () {
      this.queryParams = {
        Limit: 50
      }

      this.getDataList(1)
    },

    getTableHeight () {
      const paddingBottom = this.page.total > this.queryParams.Limit ? 50 : 9
      const mainPadding = 30
      const thead = 56
      this.height =
        this.$refs.content.offsetHeight -
        this.$refs.search.offsetHeight -
        thead -
        paddingBottom -
        mainPadding

      this.width = this.$refs.search.offsetWidth - 10
    },

    exportExcel () {
      const q = { ...this.queryParams }

      if (q.BeginDate) {
        q.BeginDate = q.BeginDate.format()
      }
      if (q.EndDate) {
        q.EndDate = q.EndDate.format()
      }

      api.exportReport(q).then((resp) => {
        fileDownload(
          resp,
          '充值资金统计' + dayjs().format('YYYYMMDDHHmmss') + '.xlsx'
        )
      })
    }
  }
})
</script>

<style lang="less" scoped></style>
